<script>
import { required } from 'vuelidate/lib/validators'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
// import Service from './service'
import DBar from '@components/dbar'

import axios from 'axios'

export default {
  page: {
    title: 'Service SLA',
    meta: [{ name: 'description', content: 'description' }]
  },
  components: { Layout, PageHeader, DBar },
  data () {
    return {
      title: 'Service SLA',
      category: 'List',
      appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
      items: [
        {
          text: 'Home',
          href: '/'
        },
        {
          text: 'Service SLA',
          active: true
        }
      ],
      data: [],
      totalRows: 0,
      graphs: [
        {
          'source': '/pan/xdr/agg/date/day?collection=cortex_incidents&variable=incident.incident.creation_time&match=incident.incident.severity,high',
          'id': 'widget2',
          'name': 'CANTIDAD DE INCIDENTES DE SEVERIDAD ALTA',
          'cols': 'col-md-6',
          'height_class': 'tall_widget',
          'component': 'dbar',
          'type': 'bar',
          'colors': ['#DC001E'],
          'range': true,
          'refresh': 60000
        }
      ],
      wData: [
        {
          title: 'Incidents Stats - Last 30 days',
          data: [
            {
              icon: 'wind',
              text: 'Total number of incidents',
              reference: 'incCount'
            },
            {
              icon: 'alert-octagon',
              text: 'High severity, response started in less than 60 mins.',
              reference: 'incHighUnderMTTR',
              class: 'icon-dual-danger'
            },
            {
              icon: 'alert-triangle',
              text: 'Medium severity, response started in less than 90 mins.',
              reference: 'incMediumUnderMTTR',
              class: 'icon-dual-warning'
            },
            {
              icon: 'alert-circle',
              text: 'Low severity, response started in less than 240 mins.',
              reference: 'incLowUnderMTTR',
              class: 'icon-dual-success'
            }
          ]
        },
        {
          title: 'Incidents Distribution - Last 30 days',
          data: [
            {
              icon: 'wind',
              text: 'Incidents',
              reference: 'incCount'
            },
            {
              icon: 'alert-octagon',
              text: 'High severity incidents',
              reference: 'incCountHigh',
              class: 'icon-dual-danger'
            },
            {
              icon: 'alert-triangle',
              text: 'Medium severity incidents',
              reference: 'incCountMedium',
              class: 'icon-dual-warning'
            },
            {
              icon: 'alert-circle',
              text: 'Low severity incidents',
              reference: 'incCountLow',
              class: 'icon-dual-success'
            }
          ]
        },
        {
          title: 'Response Average Times - Last 30 days',
          data: [
            {
              icon: 'wind',
              text: 'Average response time (hours)',
              reference: 'mttrAvgTime'
            },
            {
              icon: 'alert-octagon',
              text: 'Average response time High severity (hours)',
              reference: 'mttrHighAvgTime',
              class: 'icon-dual-danger'
            },
            {
              icon: 'alert-triangle',
              text: 'Average response time Medium severity (hours)',
              reference: 'mttrMediumAvgTime',
              class: 'icon-dual-warning'
            },
            {
              icon: 'alert-circle',
              text: 'Average response time Low severity (hours)',
              reference: 'mttrLowAvgTime',
              class: 'icon-dual-success'
            }
          ]
        }
      ]
    }
  },
  validations: {
    event: {
      title: { required },
      category: { required }
    }
  },
  computed: {
    computedData: function () {
      let that = this
      let ave = {}
      ave.incAvgTime = ((that.data.reduce((prev, cur) => prev + cur.creation_to_modification_minutes, 0) / that.data.length) / 60 || 0).toFixed(2)
      ave.incHighAvgTime = ((that.data.filter(inc => inc.severity === 'high').reduce((prev, cur) => prev + cur.creation_to_modification_minutes, 0) / that.data.filter(inc => inc.severity === 'high').length / 60) || 0).toFixed(2)
      ave.incMediumAvgTime = ((that.data.filter(inc => inc.severity === 'medium').reduce((prev, cur) => prev + cur.creation_to_modification_minutes, 0) / that.data.filter(inc => inc.severity === 'medium').length / 60) || 0).toFixed(2)
      ave.incLowAvgTime = ((that.data.filter(inc => inc.severity === 'low').reduce((prev, cur) => prev + cur.creation_to_modification_minutes, 0) / that.data.filter(inc => inc.severity === 'low').length / 60) || 0).toFixed(2)
      ave.mttrAvgTime = ((that.data.reduce((prev, cur) => prev + cur.mttr_minutes, 0) / that.data.length / 60) || 0).toFixed(2)
      ave.mttrHighAvgTime = ((that.data.filter(inc => inc.severity === 'high').reduce((prev, cur) => prev + cur.mttr_minutes, 0) / that.data.filter(inc => inc.severity === 'high').length / 60) || 0).toFixed(2)
      ave.mttrMediumAvgTime = ((that.data.filter(inc => inc.severity === 'medium').reduce((prev, cur) => prev + cur.mttr_minutes, 0) / that.data.filter(inc => inc.severity === 'medium').length / 60) || 0).toFixed(2)
      ave.mttrLowAvgTime = ((that.data.filter(inc => inc.severity === 'low').reduce((prev, cur) => prev + cur.mttr_minutes, 0) / that.data.filter(inc => inc.severity === 'low').length / 60) || 0).toFixed(2)
      ave.incCount = (that.data.reduce((prev, cur) => prev + 1, 0))
      ave.incCountHigh = (that.data.filter(inc => inc.severity === 'high').reduce((prev, cur) => prev + 1, 0))
      ave.incCountMedium = (that.data.filter(inc => inc.severity === 'medium').reduce((prev, cur) => prev + 1, 0))
      ave.incCountLow = (that.data.filter(inc => inc.severity === 'low').reduce((prev, cur) => prev + 1, 0))
      ave.incHighUnderMTTR = (((that.data.filter(inc => inc.severity === 'high' && inc.mttr_minutes <= that.appConfig.mttr_high).reduce((prev, cur) => prev + 1, 0) / that.data.filter(inc => inc.severity === 'high').length) * 100) || 0).toFixed(2) + ' %'
      ave.incMediumUnderMTTR = (((that.data.filter(inc => inc.severity === 'medium' && inc.mttr_minutes <= that.appConfig.mttr_medium).reduce((prev, cur) => prev + 1, 0) / that.data.filter(inc => inc.severity === 'medium').length) * 100) || 0).toFixed(2) + ' %'
      // ave.incLowUnderMTTR = (that.data.filter(inc => inc.severity === 'low').reduce((prev, cur) => prev + 1, 0) || 0)
      ave.incLowUnderMTTR = (((that.data.filter(inc => inc.severity === 'low' && inc.mttr_minutes <= that.appConfig.mttr_low).reduce((prev, cur) => prev + 1, 0) / that.data.filter(inc => inc.severity === 'low').length) * 100) || 0).toFixed(2) + ' %'

      return ave
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      let that = this
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      // axios.get(`${baseURL}/pan/xdr/report/service?created_after_minutes=1440`).then((response) => {
      axios.get(`${baseURL}/pan/xdr/report/service?include=incident.incident,by360&created_after_minutes=43200&limit=9999`).then((response) => {
        if (response.status === 200) {
          that.data = response.data.data.map(function (entry) {
            return {
              incident_id: entry.incident_id,
              status: entry.status,
              severity: entry.severity,
              description: entry.description,
              manual_severity: entry.manual_severity,
              alert_count: entry.alert_count,
              creation_time: new Date(entry.creation_time['$date']).toLocaleString(),
              modification_time: new Date(entry.modification_time['$date']).toLocaleString(),
              creation_to_now_minutes: entry.creation_to_now_minutes,
              modification_to_now_minutes: entry.modification_to_now_minutes,
              creation_to_modification_minutes: entry.creation_to_modification_minutes,
              mttr_minutes: entry.mttr_minutes
            }
          })
        }
      })
        .catch(function (error) {
          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('idToken')
            that.$router.push({ name: 'Home' })
          }
        })
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
    />
    <div class="row">
      <template v-for="wD in wData">
        <div class="col-md-6 col-xl-4">
          <div class="card">
            <!--            <div class="card-body p-0">-->
            <div class="card-body pt-2">
              <h6 class="card-title border-bottom p-3 mb-0 header-title">
                {{ wD.title }}
              </h6>
              <div
                v-for="widget in wD.data"
                :key="widget.icon"
              >
                <div class="media px-3 py-3 border-bottom">
                  <div class="media-body">
                    <h4 class="mt-0 mb-1 font-size-22">
                      {{ computedData[widget.reference] }}
                    </h4>
                    <span class="text-muted">{{ widget.text }}</span>
                  </div>
                  <feather
                    :type="widget.icon"
                    class="align-self-center icon-lg mr-4"
                    :class="widget.class || 'icon-dual'"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <!--      <div class="row">-->
      <!--        <template v-for="graph in graphs">-->
      <!--          <DBar-->
      <!--              :source = graph.source-->
      <!--              :type = graph.type-->
      <!--              :colors = graph.colors-->
      <!--              :start = graph.start-->
      <!--              :end = graph.end-->
      <!--              :range = graph.range-->
      <!--          />-->
      <!--        </template>-->
      <!--      </div>-->
    </div>
  </Layout>
</template>
